import { Location } from "@angular/common";
import { Inject, Injectable } from "@angular/core";

import { AlternatesPaths } from "@hermes/api-model-category";
import { StoryDeprecated } from "@hermes/api-model-editorial";
import { INFRA_SETTINGS, LOCALE } from "@hermes/app-core";
import { InfraSettings } from "@hermes/env-infra";
import { AlternateService } from "@hermes/fragments/alternates";
import { Hreflang, Locale, localeFromHrefLang } from "@hermes/locale";
import { HeadService } from "@hermes/utils-generic/services/head";

@Injectable()
export class StoryHeadService {
    constructor(
        @Inject(INFRA_SETTINGS) private infraSettings: InfraSettings,
        @Inject(LOCALE) private locale: Locale,
        private headService: HeadService,
        private alternateService: AlternateService,
        private location: Location,
    ) {}

    /**
     * Add metatags for story
     */
    public addMetaTagsStory(story: StoryDeprecated): void {
        this.headService.cleanExistingMetas();

        const storyMeta = story.storyContent.meta;
        const currentUrlWithoutParameters = this.getCurrentUrl().replace(
            /\?.*/,
            "",
        );

        this.headService.setTitle(storyMeta.title);
        this.headService.addDescriptionMetaInformations(storyMeta.description);
        this.headService.addCanonicalUrl(currentUrlWithoutParameters);
        this.headService.addItemPropMetaInformations(
            storyMeta.itempropName,
            storyMeta.itempropDescription,
            storyMeta.itempropImage,
        );
        this.headService.addOgMetaInformations(
            "website",
            storyMeta.ogTitle,
            storyMeta.ogDescription,
            currentUrlWithoutParameters,
            storyMeta.ogImage,
        );
        this.headService.addTwitterMetaInformations(
            "summary",
            storyMeta.twitterTitle,
            storyMeta.twitterDescription,
            currentUrlWithoutParameters,
        );
        this.addAlternatesPathsForStory(story.altPaths, story.path);
    }

    private addAlternatesPathsForStory(
        alternatePaths: Partial<Record<Hreflang, string>>,
        storyPath: string,
    ): void {
        const pathToModuleStory = this.location
            .path()
            .replace(`${storyPath}/`, "")
            .replace(/\?.*/, "");
        const alternatesUrls = {} as AlternatesPaths;

        (Object.keys(alternatePaths) as Hreflang[]).forEach((hreflang) => {
            const urlPrefix = localeFromHrefLang(hreflang).urlPrefix;
            alternatesUrls[
                hreflang
            ] = `${urlPrefix}${pathToModuleStory}${alternatePaths[hreflang]}/`;
        });

        this.alternateService.addAlternatesPaths(alternatesUrls);
    }

    private getCurrentUrl(): string {
        const currentURL = `${this.infraSettings.frontend}${
            this.locale.urlPrefix
        }${this.location.path()}`;

        return decodeURI(currentURL);
    }
}
